import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import { AppComponent } from './app.component';
import { TravelBoundaryComponent } from './travel-boundary/travel-boundary.component';
import { ViewMapComponent } from './view-map/view-map.component';
import {SpinnerModule} from 'primeng/primeng';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { RouteComponent } from './route/route.component';
import { MainComponent } from './main/main.component';


@NgModule({
  declarations: [
    AppComponent,
    ViewMapComponent,
    ErrorDialogComponent,
    TravelBoundaryComponent,
    RouteComponent,
    MainComponent
  ],
  imports: [
    BrowserModule, FormsModule, HttpClientModule, ReactiveFormsModule, SpinnerModule, NgbModule
  ],
  providers: [],
  entryComponents: [
    ErrorDialogComponent
  ],
  exports: [
    ErrorDialogComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
